import { Component } from '@angular/core';
import { ImportsModule } from '../imports';
import { MessagingService } from '../services/messaging.service';

@Component({
  selector: 'app-warehouse-report',
  standalone: true,
  imports: [ImportsModule],
  templateUrl: './warehouse-report.component.html',
  styleUrl: './warehouse-report.component.css'
})
export class WarehouseReportComponent {

  constructor(private messagingService: MessagingService) {
    this.messagingService.showHttpError("error", "Not Authorized", "Failed to load data.");
  }

}
